import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

export default function TermsConditions() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - A Plus A Driving School</title>
        <meta name="description" content="Terms and Conditions for A Plus A Driving School. Read our terms of service and enrollment policies." />
      </Helmet>
      <div className="py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-8">
            Terms & Conditions
          </h1>
          <div className="text-sm text-secondary-text mb-8">
            Last updated: January 2026
          </div>
          <div className="prose prose-lg max-w-none space-y-6 text-secondary-text">
            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using A Plus A Driving School&apos;s website and services, you accept and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                2. Enrollment and Registration
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Students must meet age requirements (15.5+ for teen programs)</li>
                <li>Valid learner&apos;s permit may be required for certain courses</li>
                <li>Registration is subject to availability</li>
                <li>We reserve the right to refuse enrollment</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                3. Payment Terms
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Full payment or approved payment plan is required before course start</li>
                <li>All prices are in USD and subject to change</li>
                <li>Payment plans are available upon request and approval</li>
                <li>Late payments may result in course suspension</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                4. Attendance and Completion
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Regular attendance is required for course completion</li>
                <li>Make-up sessions may be available for excused absences</li>
                <li>Students must complete all required hours to receive certification</li>
                <li>We reserve the right to dismiss students for inappropriate behavior</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                5. Cancellation and Refund Policy
              </h2>
              <p>
                Please refer to our <Link to="/refund-policy" className="text-primary hover:text-accent">Refund Policy</Link> for detailed information about cancellations and refunds.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                6. Liability
              </h2>
              <p>
                A Plus A Driving School maintains comprehensive insurance coverage. Students and parents/guardians acknowledge that driving instruction involves inherent risks and agree to hold the school harmless for any incidents that may occur during instruction, except in cases of gross negligence.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                7. Code of Conduct
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respectful behavior toward instructors and staff is required</li>
                <li>No use of drugs or alcohol before or during instruction</li>
                <li>Follow all traffic laws and safety regulations</li>
                <li>Violation of conduct rules may result in immediate dismissal</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                8. Intellectual Property
              </h2>
              <p>
                All course materials, content, and intellectual property are owned by A Plus A Driving School and may not be reproduced or distributed without permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                9. Contact Information
              </h2>
              <div className="bg-gray-50 p-4 rounded-lg mt-4">
                <p className="font-semibold">A Plus A Driving School</p>
                <p>10 Wellington Drive, Stafford, VA 22554</p>
                <p>Phone: <a href="tel:540-615-2418" className="text-primary hover:text-accent">540-615-2418</a></p>
                <p>Email: <a href="mailto:aplusavadrivingschool@gmail.com" className="text-primary hover:text-accent">aplusavadrivingschool@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

